<template>
    <!-- <div id="game_banner_container" class="" v-if="showGameBanner">
        <div id="game_banner_img" class="euro_btn" @click.prevent="selectGameBanner()" :style="position=='b'?'padding: 5px 0;':''">
            <template v-if="cookies_lang == 'zh_TW'">
                <img :src="gameBannerImage.imgList_tw" style="width: 100%;" v-if="position == 't'">
            </template>
            <template v-else-if="cookies_lang == 'zh_CN'">
                <img :src="gameBannerImage.imgList_cn" style="width: 100%;" v-if="position == 't'">
            </template>
            <template v-else-if="cookies_lang == 'th_TH'">
                <img :src="gameBannerImage.imgList_th" style="width: 100%;" v-if="position == 't'">
            </template>
            <template v-else-if="cookies_lang == 'vn_VN'">
                <img :src="gameBannerImage.imgList_vn" style="width: 100%;" v-if="position == 't'">
            </template>
            <template v-else-if="cookies_lang == 'id_ID'">
                <img :src="gameBannerImage.imgList_id" style="width: 100%;" v-if="position == 't'">
            </template>
            <template v-else-if="cookies_lang == 'pt_PT'">
                <img :src="gameBannerImage.imgList_pt" style="width: 100%;" v-if="position == 't'">
            </template>
            <template v-else-if="cookies_lang == 'es_MX'">
                <img :src="gameBannerImage.imgList_sp" style="width: 100%;" v-if="position == 't'">
            </template>
            <template v-else>
                <img :src="gameBannerImage.imgList_en" style="width: 100%;" v-if="position == 't'">
            </template>
            <span class="" :style="{ 'background-image': 'url(' + gameBannerImage.imgIco + ')' }" style="width: 20px;height: 20px;background-size: 100% auto;display: inline-flex;"  v-if="position == 'b'"></span>

        </div>
    </div> -->
    <div class="slider-box" v-if="showGameBanner">
        <div class="slides">
            <img src="assets/images/banner/slider01.png" alt="slider01" class="slide active">
            <img src="assets/images/banner/slider02.png" alt="slider02" class="slide">
        </div>
        <button class="prev notranslate" @click="showPrev()">&#10094;</button>
        <button class="next notranslate" @click="showNext()">&#10095;</button>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
// import sportMatchCount from '@/vue/mixins/sportMatchCount'
import EventBus from '@/vue/events/event-bus'

export default {
    // mixins: [ sportMatchCount ],
    computed: {
        ...mapGetters([
            "arr_selectedTemplate", 
            "isGameBannerSelected", 
            "gameBannerSportId", 
            "sportList", 
            "isOtr",
            "market",
            "currSlideIndex",
        ]),
    },
    props:{
        position: null,
    },
    data () {
        return {
            showGameBanner: false,
            gameBannerImage: window._gameBannerImage,
            cookies_lang: window._cookie,
            langList: window._lang,
            intervalId: null,
        }
    },
    methods: {
        async selectGameBanner() {
            return
            if(window._gameBanner && !window._imageBanner) {
                let vue = this
                this.$store.commit("GAMEBANNER_SELECTED", true);

                if(this.isOtr){
                    this.$store.commit('IS_CORRECTSCORE', false)
                    this.$store.commit('SELECTED_STATE', '')
                    this.$store.commit('SHOW_CALENDAR', false)
                    this.$store.commit('IS_OTR', false)
                    EventBus.$emit('enableLoading', true)
                    this.$store.commit('IS_PARLAY', false)
                    this.$store.commit('IS_SPECIAL', false)
                    this.$store.commit('IS_VIP', false)
                    this.$store.commit('SELECTED_MARKET', this.$store.getters.market.tdyMarket.key)
                    this.$store.commit('MARKETTOGGLE', this.$store.getters.market.tdyMarket.key)
                    this.$store.commit('CURRENT_TAB', 1)
                    this.$store.dispatch('changeTemplate', {
                        templateId: 2,
                        marketKey: this.$store.getters.market.tdyMarket.key,
                        plytype: 1,
                        bettypeid: 1,
                        sportId: this.$store.getters.gameBannerSportId,
                        subTemplateId: 1,
                    })
                }

                // EventBus.$emit('CHANGE_SPORT', this.$store.getters.sportList[0].sprtId)
                $( ".scroller" ).scrollTop( 0 );
                this.$store.commit('IS_HIDE_LEAGUE', false)
                var container = $(".sub-m-menu");
                var container2 = $(".sub-background");
                if (container || container2) {
                    container.hide();
                    container2.hide();
                }
                this.$store.commit('SHOW_FLOATING', false)
                $( ".scroll" ).scrollTop( 0 );
                this.$store.commit('VIRTUAL_DATA_LIST', [])
                this.$store.commit('LOADGAMEHEADER', false)
                this.$store.commit('EVENTLIST', [])
                this.$store.commit('TODAYRBEVENTLIST', [])
                this.$store.commit('SWIPE_MODE', 1)
                $('.odd-t-i-wrapper').removeClass('status2') // swipe right
                $('.standard-odd-l-w').removeClass('status2')
                this.$store.commit('SORTEDEVENTLIST', [])
                this.$store.commit('COOKIE_LEAGUE', {
                    remove : true,
                })
                // get banner game count by market
                // ----- START -----
                if(this.showGameBanner){
                    let market = '1,2,3'
                    await this.$store.dispatch('getEventList', {
                        market: market,
                        token: token.arr_2,
                        callback: ((res) => {
                            if(this.$store.getters.arr_sportList){
                                if(this.$store.getters.arr_sportList[this.market.inPlayMarket.key]) {
                                    this.getGameBannerCount(this.market.inPlayMarket.key, this.$store.getters.arr_sportList[this.market.inPlayMarket.key][1])
                                }else {
                                    this.getGameBannerCount(this.market.inPlayMarket.key, 0)
                                }
                                if(this.$store.getters.arr_sportList[this.market.tdyMarket.key]) {
                                    this.getGameBannerCount(this.market.tdyMarket.key, this.$store.getters.arr_sportList[this.market.tdyMarket.key][1])
                                }else {
                                    this.getGameBannerCount(this.market.tdyMarket.key, 0)
                                }
                                if(this.$store.getters.arr_sportList[this.market.earlyMarket.key]) {
                                    this.getGameBannerCount(this.market.earlyMarket.key, this.$store.getters.arr_sportList[this.market.earlyMarket.key][1])
                                }else {
                                    this.getGameBannerCount(this.market.earlyMarket.key, 0)
                                }
                            }
                            if(this.inPlyCount > 0){
                                market = this.market.tdyMarket.key
                            }else{
                                if(this.tdyCount > 0){
                                    market = this.market.tdyMarket.key
                                }else{
                                    if(this.earlyCount > 0){
                                        market = this.market.earlyMarket.key
                                    }
                                }
                            }
                            let tab = market == this.market.tdyMarket.key ? 1 : 2
                            this.$store.commit('CURRENT_TAB', tab)
                            this.$store.commit('MARKETTOGGLE', market)	
                            if(this.arr_selectedTemplate.templateId == 21){
                                EventBus.$emit('parlaySportTemplate', this.$store.getters.gameBannerSportId)
                            }else{
                                EventBus.$emit('sportTemplate', this.$store.getters.gameBannerSportId)
                            }
                        }).bind(this)
                    })
                }
                // ----- END   -----
                // if(this.arr_selectedTemplate.templateId == 21){
                //     EventBus.$emit('parlaySportTemplate', this.$store.getters.gameBannerSportId)
                // }else{
                //     EventBus.$emit('sportTemplate', this.$store.getters.gameBannerSportId)
                // }
            }
        },
        getGameBannerCount(market, count) {
            if(this.market.inPlayMarket.key == market) {
                this.inPlyCount = count
            } else if (this.market.tdyMarket.key == market) {
                this.tdyCount = count
            } else if (this.market.earlyMarket.key == market) {
                this.earlyCount = count
            }
        },
        showNext() {
            let total = $('.slide').length
            let currSlideIndex = (this.currSlideIndex + 1) % total;
            this.$store.commit('CURR_SLIDE_INDEX', currSlideIndex)
            this.showSlide(currSlideIndex);
        },
        showPrev() {
            let total = $('.slide').length
            let currSlideIndex = (this.currSlideIndex - 1 + total) % total;
            this.$store.commit('CURR_SLIDE_INDEX', currSlideIndex)
            this.showSlide(currSlideIndex);
        },
        showSlide(index) {
            let slides = document.querySelectorAll('.slide')
            slides.forEach((slide, i) => {
                slide.classList.toggle('active', i === index);
            });
        },
    },
    beforeMount() {
        if(window._gameBanner) {
            if(window._imageBanner) {  // only show image, no link when click
                if(['t'].includes(this.position)) {
                    this.showGameBanner = true
                }
            } else {
                this.showGameBanner = true
                this.$store.commit('GAME_BANNER_ID', window._gameBanner)
                this.$store.commit('GAME_BANNER_SPORT_ID', this.$store.getters.sportList[0].sprtId)
            }
        }
    },
    mounted() {
        this.intervalId = setInterval(this.showNext, 10000);
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
    destroyed() {
    },
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/score/vue/apps/home/gameBanner.vue